import { all, takeEvery, put, call } from "redux-saga/effects";
import { TRANSACTION_HISTORY } from "./types";
 import { toast } from "react-toastify";
import { transactionhistoryRequest,transactionhistorySuccess,transactionhistoryFailure} from "../Transactionhistory/action";
// import userLogin from "../../services/authServices";
import transactionhistory from "../../services/transactionhistoryservices";
import transactionhistoryapicall from "../../services/transactionhistoryservices";
// import { getBasePath } from "../../Utils/common/routes";
export function* usertransaction({page,clientId,isAdmin,agentId}) {
//console.log('page', page, clientId)
//   const { email , password } = payload;
  yield put(transactionhistoryRequest());
  try {
    
    
    // const result = yield call(userLogin, { email, password });
    const result = yield call(transactionhistoryapicall,page,clientId,isAdmin,agentId);
    
    if (result) {
  
      yield put(transactionhistorySuccess(result));
      // yield history.push('/dashboard');
      // history.go('./dashboard')
     
      // toast.success("logged in Successfully");
    } 
  } catch (error) {
    // yield put(loginUserFailure(error.response.data));
  }
}

export default function* transactionsaga() {
  
  yield all([takeEvery(TRANSACTION_HISTORY, usertransaction)]);
}


